export class Validation {
  public static VALID_URL = new RegExp(
    /^ *(((https?):)?\/\/)?((([a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(\.([a-z\u00a1-\uffff0-9]-*){1,62}[a-z\u00a1-\uffff0-9]+)*(\.([a-z\u00a1-\uffff]{2,})))(:\d{2,5})?([/?#]\S*)? *$/i,
  );

  public static EMAIL_REGEX = new RegExp(
    /^[a-zA-Z0-9_.\-+](?:[a-z0-9!#$%&'*+/=?^_`{|}~-]*(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i,
  );

  public static validateWithRegex = (regex: RegExp, input: string) => {
    if (!regex || input === null) {
      return false;
    } else {
      return regex.test(input);
    }
  };

  public static isNullOrBlank = (input: string) => !input || input.trim().length === 0;

  public static isFormattedEmail = (input: string) => Validation.validateWithRegex(Validation.EMAIL_REGEX, input);
}
